module.exports = __webpack_public_path__ + "8abaee407e5305769b434f4d87b238a2.svg";